module.exports = __webpack_public_path__ + "images/display_chronic_disease_large.svg";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/display_chronic_disease_large.svg
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--1-0!/tool/node_modules/img-loader/index.js??ref--1-1!/tool/project/client/src/site__mhf/images/display_chronic_disease_large.svg
// module chunks = site__mhf